import { Component, input } from '@angular/core';

@Component({
  selector: 'op-phone',
  standalone: false,
  templateUrl: './phone.html',
  styleUrl: './phone.css',
})
export class Phone {
  readonly screen=input.required<string>();
  readonly title=input.required<string>();
}
